import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4602Model } from './kymw4602.model';
import { KYMW4602InputModel } from './vo/kymw4602-input.model';
import { SetTagPCodeService } from './api-services/set-tag-pcode.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

/**
 * タグ一括設定を管理するクラス
 *
 * @export KYMW4602Component
 * @class KYMW4602Component
 */
@Component({
  selector: 'app-kymw4602',
  templateUrl: 'kymw4602.component.html',
  styleUrls: ['kymw4602.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4602Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('btn_SetPCode', { static: false }) btn_SetPCode: ElementRef;
  @ViewChild('txt_PCodes', { static: false }) txt_PCodes: ElementRef;

  public model: KYMW4602Model = new KYMW4602Model();

  // Pコード最大行数
  public static readonly PCODE_MAX = 1000;

  /**
   * Creates an instance of KYMW4602Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {SetTagPCodeService} setTagPCodeService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4602Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private setTagPCodeService: SetTagPCodeService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4602Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4602';
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4602Component
   */
  public ngAfterViewInit(): void {}

  /**
   * ボタン押下 設定
   *
   * @memberof KYMW4602Component
   */
  public setPCodes() {
    this.model.registedPCodes = [];
    // バリデーション 必須入力
    if (!this.model.PCodes) {
      this.dialogService.openAlertGetMessage('W0001', ['Ｐコード']);
      return;
    }
    // APIリクエスト
    this.setTagPCodeService.execute(this.model, () => {
      if (this.model.failLines.length > 0) {
        this.dialogService.openAlertGetMessage(
          'I0507',
          ['タグPコード一括紐づけ設定が完了', this.model.failLines.slice(0, 10).join(',')],
          _e => {
            this.closeFunction();
          }
        );
      } else {
        this.dialogService.openAlertGetMessage(
          'I0106',
          ['タグPコード一括紐づけ設定が完了'],
          _e => {
            this.closeFunction();
          }
        );
      }
    });
  }

  /**
   * 行数表示
   *
   * @memberof KYMW4602Component
   */
  public getCounter(): string {
    return `${String(this.model.counter).padStart(
      KYMW4602Component.PCODE_MAX.toString().length,
      ''
    )}件/${KYMW4602Component.PCODE_MAX}件`;
  }

  /**
   * 行数最大
   *
   * @memberof KYMW4602Component
   */
  public getMax(): string {
    return `${KYMW4602Component.PCODE_MAX}`;
  }

  /**
   * モーダル閉じる場合 ダイアログ表示
   *
   * @param data
   * @memberof KYMW4602Component
   */
  onClickClose(): void {
    // Pコードに入力があれば破棄確認メッセージ表示
    if (this.model.PCodes) {
      this.dialogService.openAlertGetMessage('Q0174', [], e => {
        if (e === PlessAlert.Yes) {
          super.onClickClose();
        }
      });
    } else {
      super.onClickClose();
    }
  }

  /**
   * パラメータ格納 呼び出し側から利用
   *
   * @param data
   * @memberof KYMW4602Component
   */
  public setParams(data: KYMW4602InputModel) {
    this.model.tagId = data?.[0];
    this.model.tagName = data?.[1];
  }
}
